import styled from '@emotion/styled'
import { Box } from 'rebass'

export const StyledPostHeader = styled(Box)`
  color: lime;
`
